import * as React from 'react';
export const IcWorkshop = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M18.52 15.59l-1.29-1.3a1 1 0 00-1.41 0l-1.59-1.58 1-1c.44.17.907.267 1.38.29a4.51 4.51 0 004.5-4.5 4.46 4.46 0 00-.7-2.39l-2.3 2.3L16.7 6 19 3.7a4.46 4.46 0 00-2.39-.7 4.51 4.51 0 00-4.5 4.5c.005.484.09.963.25 1.42l-1 1-2.43-2.51L7 3.55A1 1 0 006.27 3a1 1 0 00-.87.28l-2 2a1 1 0 00.25 1.61l3.87 1.93 2.47 2.47-6.29 6.3a2 2 0 102.82 2.82l6.3-6.29 1.58 1.59a1 1 0 000 1.41l1.3 1.29 2 2a2 2 0 002.82-2.82l-2-2z'
      fill='currentColor'
    />
  </svg>
);
